module.exports = __webpack_public_path__ + "static/media/cryotherapy-secondary.2832d5f8.jpg";